import { HEADERS } from './fixtures';
import { optionActions } from 'core/Option';
import { useTranslation } from 'react-i18next';
import { validationSchema } from 'shared/utils';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    FormGroup,
    Input,
    Modal,
    Table
} from 'mol-ui';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useErrors,
    useObjectState,
    useSelector
} from 'hooks';

const DEFAULT_AREA = {
    name: ''
};

const AreaListing = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { clearError, clearErrors, errors, setErrors } = useErrors();
    const [selectedArea, setSelectedArea, setValue] = useObjectState(null);

    const {
        areas,
        areasError,
        areasLoading,
        areasStatus
    } = useSelector('option');

    useEffect(() => {
        setSelectedArea(null);
    }, [areas, setSelectedArea]);

    useEffect(() => {
        dispatch(optionActions.getAreas());
    }, []);

    const actionController = [{
        icon: 'edit',
        onClick: setSelectedArea,
        title: t('Editar')
    }];

    const handleChange = (id, value) => {
        clearError(id);
        if (!!areasError[id]) {
            const newErrors = { ...areasError };
            delete newErrors[id];
            dispatch(optionActions.setOptionAreasError(newErrors));
        }
        setValue(id, value);
    };

    const handleNewArea = () => {
        dispatch(optionActions.setOptionAreasError({}));
        clearErrors();
        setSelectedArea({ ...DEFAULT_AREA });
    };

    const onSubmit = () => {
        if (!validate()) return;
        dispatch(optionActions.upsertArea(selectedArea));
    };

    const validate = () => {
        const { errors, isValid } = validationSchema({
            name: [!!selectedArea?.name?.trim(), t('Requerido')]
        });
        setErrors(errors);
        return isValid;
    };

    return (
        <Container>
            <Modal active={ !!selectedArea }>
                <FormGroup label={ t('Nombre') } width="300px">
                    <Input
                        error={ errors?.name ?? areasError?.name }
                        value={ selectedArea?.name }
                        width="100%"
                        onChange={ value => handleChange('name', value) }
                    />
                </FormGroup>
                <ButtonFooter margin="20px 0px 0px 0px">
                    <ExpandButton
                        danger
                        caption={ t('Cancelar') }
                        disabled={ areasStatus === 'loading' }
                        size={ 80 }
                        onClick={ () => setSelectedArea(null) }
                    />
                    <ExpandButton
                        caption={ selectedArea?.id ? t('Editar') : t('Crear') }
                        loading={ areasStatus === 'loading' }
                        size={ 80 }
                        onClick={ onSubmit }
                    />
                </ButtonFooter>
            </Modal>
            <Container flex="1">
                <Table
                    config={ HEADERS }
                    data={ areas }
                    loading={ areasLoading }
                    rowActions={ actionController }
                />
            </Container>
            <ButtonFooter>
                <ExpandButton
                    caption={ t('Nueva zona') }
                    icon="add"
                    size={ 100 }
                    width={ 200 }
                    onClick={ handleNewArea }
                />
            </ButtonFooter>
        </Container>
    );
};

export default AreaListing;
